import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinct, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';
import { de } from 'date-fns/locale';
import { url } from 'inspector';

export interface FilterData {
  filter: string;
  AdvanceSearch: any;
}

@Component({
    selector: 'app-view-diary',
    templateUrl: './view-diary.component.html',
    styleUrls: ['./view-diary.component.css'],
    standalone: false
})

export class ViewDiaryComponent implements OnInit {
  url: string;
  Diary: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  MsgType: number;
  DisplayMessage: string;
  FormSearchPlanDiary: FormGroup;
  advanceSearchValue: any;
  pageNumber: number;
  RightsID: string;
  filteredData: any = [];
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;

  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder) {
     this.url = AppComponent.baseURL; }

  ngOnInit() {
  this.RightsID = localStorage.getItem('UserRight');
  if (this.RightsID.includes('202024001') || this.RightsID.includes('202024021') || this.RightsID.includes('202024000')) {
  } else {
    window.location.href = "module/0";
  }
  this.pageNumber = 1;
  this.MsgType = 1; // Loading
  this.advanceSearchValue = "";
  this.GetDiary('');
  this.FormSearchPlanDiary = this.formBuilder.group({
      txtSearch: [''], advanceSearchValue: ['']
    });

  this.FormSearchPlanDiary.get('txtSearch').valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe(value => {
    this.filterTable(value);
  });
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filterTable('')
  }
  receiveMessage(event) {
    if (event?.data?.data?.Param != null){
      localStorage.setItem('advancesearch', event.data.data.Param);
      let element: HTMLElement;
      element = document.getElementsByClassName('close')[0] as HTMLElement;
      element.click();
    }
  }
  OpenModal(url, cID, modelName, urld)    {
      let myDate = Math.floor(Math.random() * 6) + 1 ;
      this.modalURL =  url + "/0/" + cID + "/" + "4";
      this.CallFunctionOnCloseModal = urld;
      this.ModelFor = modelName;
      if (modelName == "Filter") {
        window.addEventListener("message", this.receiveMessage, false);
        this.modalURL = "filter/202024000" ; }
    }
    OpenModal1(url, cID, ContextType, NoticeID)    {
      this.modalURL =  url + "/"+ NoticeID +"/" + cID + "/" + ContextType;
      this.CallFunctionOnCloseModal = "ReturnAdvanceSearch";
      this.ModelFor = "Update Diary";
    }
    onSearchPlanDiary(SearchData) {
      this.GetDiary(SearchData.txtSearch);
    }
    ReturnAdvanceSearch() {
      if (localStorage.getItem('advancesearch') != "") {
      this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch')); }
      localStorage.setItem('advancesearch', "");
      this.GetDiary('');
      this.modalURL = '' ;
    }
  GetDiary(Param) {
    let filterData: FilterData = {
      filter: Param,
      AdvanceSearch: this.advanceSearchValue
     };
    this.http.post(this.url + 'Dashboard/SearchDiary', filterData)
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          this.Diary = null;
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          this.filteredData = [];
         } else {
          this.MsgType = 0; // No Message
          this.Diary = JSON.parse(data.toString()); 
          this.totalRecords = this.Diary.length;
          this.filterTable('');
        }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
         this.Diary = null;
       }
    );
  }

  filterTable(searchText: string) {
    if (!searchText) {
      this.filteredData = [...this.Diary];
      return;
    }
    this.filteredData = this.Diary.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }
}
